import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-dark-card relative overflow-hidden" data-id="element-244">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-245"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-246">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-247">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-248">
            <span className="text-2xl" data-id="element-249">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-250">
            The most complete Research Methods teaching system for high school
            educators worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-251">
            Research Methods Ready™
          </h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-252">
            6-in-1 · 5 Strategic Bonuses · Everything ready to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-253">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-dark-border" data-id="element-254">
            <div className="flex items-start gap-3" data-id="element-255">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-256" />
              <p className="text-gray-400 text-sm" data-id="element-257">
                This is not theory copied from an academic textbook.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-258">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-259" />
              <p className="text-gray-400 text-sm" data-id="element-260">
                This is not a collection of disconnected activities.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-261">
              <X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-262" />
              <p className="text-gray-400 text-sm" data-id="element-263">
                This is not material you have to completely adapt before using.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-264">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-265"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-266">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-267" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-268">
                This is a complete teaching system so you walk into every class
                with confidence and teach lessons that actually teach students
                how to research.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}